import styled from 'styled-components';

interface IStyledChatCategoryProps {
	$active: boolean;
}

const StyledContainer = styled.div<IStyledChatCategoryProps>`
	display: flex;
	align-items: center;
	column-gap: 4px;
	padding: 4.5px 6px;
	border-radius: 6px;

	font-family: GT Walsheim Pro;
	font-size: 10px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	cursor: pointer;

	background-color: ${({ $active }) =>
		$active ? '#FFFFFF' : 'rgba(0, 0, 0, 0.5)'};
	color: ${({ $active }) => ($active ? '#262628' : '#FFFFFF')};

	transition:
		background-color 0.25s ease,
		color 0.25s ease;

	&:hover {
		background-color: #ffffff;
		color: #262628;
	}
`;

export { StyledContainer };
